var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 -6.10352e-05H13.3333C5.96954 -6.10352e-05 0 5.96948 0 13.3333V66.6666C0 74.0304 5.96954 79.9999 13.3333 79.9999H66.6667C74.0305 79.9999 80 74.0304 80 66.6666V13.3333C80 5.96948 74.0305 -6.10352e-05 66.6667 -6.10352e-05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.315 52.1501C44.0505 54.3403 44.8009 57.1409 46.9911 58.4054C49.1813 59.6699 51.9819 58.9195 53.2464 56.7293L63.4297 39.0912C64.6942 36.901 63.9438 34.1004 61.7536 32.8359C59.5634 31.5714 56.7629 32.3219 55.4984 34.512L45.315 52.1501Z",
    fill: "#7AAFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0908 34.1834C22.8263 31.9933 20.0257 31.2428 17.8355 32.5074C15.6454 33.7719 14.895 36.5724 16.1595 38.7626L26.1365 56.0434C27.401 58.2336 30.2016 58.984 32.3918 57.7195C34.582 56.455 35.3324 53.6544 34.0679 51.4643L24.0908 34.1834Z",
    fill: "#468CFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9579 56.8667C46.2638 59.1287 49.1553 59.9041 51.4162 58.5988C53.6772 57.2934 54.4513 54.4016 53.1454 52.1396L43.6683 35.7249C42.3624 33.4629 39.4709 32.6875 37.21 33.9928C34.9491 35.2982 34.1749 38.19 35.4808 40.4519L44.9579 56.8667Z",
    fill: "#39FFF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7365 40.4154C45.0425 38.1535 44.2683 35.2617 42.0073 33.9563C39.7464 32.651 36.8549 33.4264 35.549 35.6883L26.2823 51.7387C24.9764 54.0006 25.7506 56.8925 28.0115 58.1978C30.2724 59.5032 33.1639 58.7277 34.4699 56.4658L43.7365 40.4154Z",
    fill: "#94B8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4375 29.5725C67.8491 29.5725 69.8041 27.6175 69.8041 25.2058C69.8041 22.7942 67.8491 20.8392 65.4375 20.8392C63.0258 20.8392 61.0708 22.7942 61.0708 25.2058C61.0708 27.6175 63.0258 29.5725 65.4375 29.5725Z",
    fill: "url(#paint0_linear_588_3152)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_588_3152",
    x1: 61.5416,
    y1: 27.1808,
    x2: 69.3333,
    y2: 23.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#7FFFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#80FADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8FCAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.8c709ba644f6ac917477fbf73ff67e1f.svg";
export { ForwardRef as ReactComponent };